<template>
    <v-dialog v-model="show" max-width="500">
        <v-card>
            <v-card-title class="headline primary primarytext--text">
                {{resource.lastname}}
                <v-btn icon @click="show = false" class="ml-auto"><v-icon color="primarytext">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text v-if="position">
                <!-- Leaflet Map (when flag is enabled) -->
                <div v-if="useLeaflet" style="width: 100%; height: 300px">
                    <l-map
                        ref="leafletMap"
                        :zoom="zoom"
                        :center="position"
                        style="height: 100%; width: 100%"
                        @ready="onMapReady"
                    >
                        <l-tile-layer
                            :url="tileLayerUrl"
                            :attribution="attribution"
                        ></l-tile-layer>
                        <l-marker :lat-lng="position"></l-marker>
                    </l-map>
                </div>

                <!-- Google Maps (legacy, when flag is disabled) -->
                <GmapMap
                    v-else
                    :center="googlePosition"
                    :zoom="7"
                    map-type-id="terrain"
                    style="width: 100%; height: 300px"
                    id="googlemap"
                >
                    <GmapMarker
                        :position="googlePosition"
                    />
                </GmapMap>

                <div v-if="resource.address">
                    {{resource.address}}<br>
                    {{resource.city}}<br>
                </div>

            </v-card-text>

            <v-card-actions>
                <v-btn class="zoezi-button-thin" color="primary" outlined @click="navigate">{{$translate('Navigate here')}}</v-btn>
                <v-spacer></v-spacer>

                <zoezi-button :text="$translate('Close')" @click="show = false" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

// Fix Leaflet default icon issue with webpack
import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

import Vue from 'vue'
export default {
    name: 'zoezi-map-dialog',

    props: ['value', 'resource'],

    components: {
        GmapMap: VueGoogleMaps.Map,
        GmapMarker: VueGoogleMaps.Marker,
        LMap,
        LTileLayer,
        LMarker
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        },
        show(show) {
            if (show != this.value) {
                this.$emit('input', show);
            }
            // Fix Leaflet map rendering when dialog opens
            if (show && this.useLeaflet) {
                this.$nextTick(() => {
                    // Give the dialog time to fully render, then invalidate map size
                    setTimeout(() => {
                        if (this.$refs.leafletMap && this.$refs.leafletMap.mapObject) {
                            this.$refs.leafletMap.mapObject.invalidateSize();
                        }
                    }, 100);
                });
            }
        }
    },


    data: () => ({
        show: false,
        zoom: 13,
        tileLayerUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }),

    computed: {
        useLeaflet() {
            return this.$api.hasFlag('flag-leaflet-maps');
        },
        position() {
            let p = this.resource?.position?.split(',');
            if (!p) return null;
            // Leaflet uses [lat, lng] array format
            return [Number(p[0]), Number(p[1])];
        },
        googlePosition() {
            // Google Maps uses {lat, lng} object format
            if (!this.position) return null;
            return {lat: this.position[0], lng: this.position[1]};
        }
    },

    methods: {
        onMapReady(mapObject) {
            // Fix map rendering in dialog - invalidate size after a short delay
            this.$nextTick(() => {
                setTimeout(() => {
                    mapObject.invalidateSize();
                }, 200);
            });
        },
        navigate() {
            const lat = this.position[0];
            const lng = this.position[1];
            let url = `https://www.google.com/maps/dir/?api=1&destination=${lat}%2C${lng}&travelmode=driving`
            window.open(url, '_blank')
        }
    },

    created() {
        // Only initialize Google Maps if not using Leaflet
        if (!this.useLeaflet) {
            Vue.use(VueGoogleMaps, {
                load: {
                    key: 'AIzaSyAkUAkjyqsYAb-FCtpUY7WdetIQUv1-slQ',
                }
            })
        }
    }
}
</script>
